import { Ruler } from "lucide-react";

const fields = [
  { key: "shoulder", label: "Shoulder" },
  { key: "bust", label: "Bust" },
  { key: "hips", label: "Hips" },
  { key: "length", label: "Length" },
  { key: "sleeve_length", label: "Sleeve Length" },
  { key: "armhole", label: "Armhole" },
  { key: "cuff", label: "Cuff" },
  { key: "button_placement", label: "Button Placement" },
  { key: "sheila_length", label: "Sheila Length" },
];

export default function MeasurementsStep({ data, update }) {
  const handleChange = (key, val) => {
    const num = val === "" ? 0 : parseFloat(val);
    if (!isNaN(num)) update({ [key]: num });
  };

  return (
    <div className="animate-fade-in" data-testid="measurements-step">
      <div className="flex items-center gap-2 mb-1">
        <Ruler className="w-4 h-4 text-[#9F7D23]" />
        <h3 className="font-['Space_Mono'] text-lg tracking-tight uppercase text-[#5C4D24]">
          Measurement Matrix
        </h3>
      </div>
      <p className="text-sm text-[#8B7536] mb-8">All measurements in centimeters (cm)</p>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-6">
        {fields.map((f) => (
          <div key={f.key}>
            <label className="font-['Space_Mono'] text-[10px] tracking-widest uppercase text-[#8B7536] block mb-2">
              {f.label}
            </label>
            <div className="relative">
              <input
                type="number"
                value={data[f.key] || ""}
                onChange={(e) => handleChange(f.key, e.target.value)}
                placeholder="0"
                data-testid={`measure-${f.key}`}
                className="tinkah-input text-xl pr-8"
                min="0"
                step="0.5"
              />
              <span className="absolute right-0 bottom-2 font-['Space_Mono'] text-xs text-[#D6D6CF]">cm</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
